import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface TimeInterval {
  id: string;
  name: string;
}

interface TimeIntervalFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const timeIntervals: TimeInterval[] = [
  { id: 'day', name: 'Day' },
  { id: 'week', name: 'Week' },
  { id: 'month', name: 'Month' },
  { id: 'year', name: 'Year' },
];

export const TimeIntervalFilter: React.FC<TimeIntervalFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedInterval = timeIntervals.find((i) => i.id === value);

  if (valueOnly) {
    return <>{selectedInterval?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={timeIntervals}
      getOptionLabel={(option) => option.name}
      value={selectedInterval || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Time Interval"
        />
      )}
    />
  );
};
